import React from 'react';

const MoneyCell = ({ renderedCellValue }) => (
  <div className="table__money-cell">
    {renderedCellValue}
  </div>
);

export default MoneyCell;
